import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS} from "./api-base"
import { getESGReqHeader } from "./tool-service";

// 查詢公告清單
export const queryNoticeRecordsList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020101")}`, method: 'post', data: ReqBody })
}

// 查詢公告明細
export const queryNoticeRecordsInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020102")}`, method: 'post', data: ReqBody })
}

// 更新公告
export const updateNoticeRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020103")}`, method: 'post', data: ReqBody })
}

// 建立公告 before
export const B2020104Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020104",true)}`, method: 'post', data: ReqBody })
}

// 建立公告
export const createNoticeRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020104")}`, method: 'post', data: ReqBody })
}

// 寄送公告
export const mailNoticeRecords = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2020105'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2020105")}`, method: 'post', data: ReqBody })
}

// 查詢現在有效公告
export const queryReleaseNoticeRecordsList = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1000101'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1000101")}`, method: 'post', data: ReqBody })
}


